import { alertColours } from '../../components/Alert/AlertBase';
import { avatarColours } from '../../components/Avatar/Avatar';
import { countColours } from '../../components/Count/Count';
import { fiveStarColours } from '../../components/FiveStar/FiveStar';
import { dividerColours } from '../../components/Divider/Divider';
import { dotIconColours } from '../../components/DotIcon/DotIcon';
import { progressBarColours } from '../../components/ProgressBar/ProgressBar';
import { triangleIndicatorColours } from '../../components/TriangleIndicator/TriangleIndicator';
import { labelColours } from '../../components/Label/Label';
import { textFieldColours } from '../../components/TextField/TextField';
import { helpTextColours } from '../../components/HelpText/HelpText';
import { fileUploadColours } from '../../components/FileUpload/FileUpload';
import { tooltipColours } from '../../components/Tooltip/Tooltip';
import { tooltipHelpIconColours } from '../../components/Tooltip/TooltipHelpIcon';
import { tooltipArrowColours } from '../../components/TooltipArrow/TooltipArrow';
import { optionColours } from '../../components/Options/Options';
import { noticebarColours } from '../../components/Noticebar/Noticebar';
import { loadingAnimationColours } from '../../components/LoadingAnimation/LoadingAnimation';
import { menuColours } from '../../patterns/Menu/Menu';
import { selectColours } from '../../components/Select/selectStyleOverrides';
import { modalColours } from '../../patterns/Modal/Modal';
import { overlayColours } from '../../components/Overlay/Overlay';
import { tourModalColours } from '../../patterns/TourModal/StepPopup';
import { sheetColours } from '../../components/Sheet/Sheet';
import { accordionColours } from '../../components/Accordion/Accordion';
import { buttonThemeConfig } from '../../components/Button/buttonThemeConfig';
import { tableColours } from '../../components/Table/Table';
import { cardColours } from '../../patterns/Card/Card';
import { IColoursCollection, IThemeColours } from './colourInterfaces';
import { progressIndicatorColours } from '../../patterns/ProgressIndicator/ProgressIndicator';
import { dropdownColours } from '../../patterns/Dropdown/Dropdown';
import { dateDisplayColours } from '../../components/DateDisplay/DateDisplay';
import { skeletonColours } from '../../components/Skeleton/Skeleton';
import { metricColours } from '../../patterns/Metric/Metric';
import { EORA_EFFECTS } from '../effects/eoraEffects';
import { interceptorColours } from '../../patterns/Interceptor/Interceptor';
import { carouselPaginationColours } from '../../patterns/Carousel/CarouselPagination';

const focusColours = ({}: IColoursCollection) => ({
  focusColours: {
    boxShadow: `${EORA_EFFECTS.EFFECTS.STYLE.FOCUS_RING.FOCUS_RING}`,
    invalid: {
      boxShadow: `${EORA_EFFECTS.EFFECTS.STYLE.FOCUS_RING.FOCUS_RING_ERROR}`
    }
  }
});

export const generateThemeColours = ({ brandColours, baseColours, eoraColours }: IThemeColours) => {
  const colours = { ...brandColours, ...baseColours, ...eoraColours };
  const componentColours = {
    ...fiveStarColours(colours),
    ...alertColours(colours),
    ...avatarColours(colours),
    ...buttonThemeConfig(colours),
    ...focusColours(colours),
    ...countColours(colours),
    ...dividerColours(colours),
    ...dotIconColours(colours),
    ...progressBarColours(colours),
    ...triangleIndicatorColours(colours),
    ...labelColours(colours),
    ...textFieldColours(colours),
    ...helpTextColours(colours),
    ...fileUploadColours(colours),
    ...tooltipArrowColours(colours),
    ...loadingAnimationColours(colours),
    ...optionColours(colours),
    ...tooltipColours(colours),
    ...tooltipHelpIconColours(colours),
    ...menuColours(colours),
    ...selectColours(colours),
    ...noticebarColours(colours),
    ...modalColours(colours),
    ...overlayColours(colours),
    ...tourModalColours(colours),
    ...sheetColours(colours),
    ...accordionColours(colours),
    ...tableColours(colours),
    ...cardColours(colours),
    ...progressIndicatorColours(colours),
    ...dateDisplayColours(colours),
    ...dropdownColours(colours),
    ...skeletonColours(colours),
    ...metricColours(colours),
    ...interceptorColours(colours),
    ...carouselPaginationColours(colours)
  };
  return {
    colours,
    ...componentColours
  };
};
